import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

export const BaseButton: FunctionComponent<ButtonProps> = (
  props: PropsWithChildren<ButtonProps>
): ReactElement => {
  const { children, ...buttonProps } = props;

  const baseButtonProps: ButtonProps = {
    classes: {
      root: 'button',
    },
    type: 'button',
    variant: 'contained',
    ...buttonProps,
  };

  return <Button {...baseButtonProps}>{children}</Button>;
};
